"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFilesTable = void 0;
exports.uploadFilesTable = [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'modules/upload/directives/uploadfilestable.tpl.html',
            scope: {
                files: '=',
                columns: '='
            },
            link: function (scope, element, attrs) {
            }
        };
    }];
